let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1p5ZO")).then(() => parcelRequire('2VrQY'));